import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { Panel } from 'primereact/panel';
import { ProgressSpinner } from 'primereact/progressspinner';
import { InputComponent } from '../../../components/InputComponent';
import * as generic from '../../../components/Generico';
import { EmpleadoConyugue as EmpleadoConyugueModel } from '../../../models/ficha/EmpleadoConyugue';
import { EmpleadoService } from '../../../service/EmpleadoService';
import { BottomActionBar } from '../../../components/ui/BottomActionBar';
import { InputActividadEconomica } from '../../../components/ui/Formularios/InputActividadEconomica';

export const EmpleadoConyugue = ({ toast, id, permss, catalogos, handlePrev, next, soloLectura }) => {

    const omodel = new EmpleadoConyugueModel({ tipoFrmEmpresa: catalogos?.tipoFrmEmpresa });
    const defaultValues = generic.funDefault(omodel.model);
    const { control, formState: { errors }, handleSubmit, reset, setError, clearErrors } = useForm({ defaultValues, shouldTrim: true });
    const empleadoService = new EmpleadoService();
    const { inDrop, inText, inCalendar } = InputComponent({ omodel, errors, control, permss, id, soloLectura });
    const [isLoading, setIsLoading] = useState(true);
    const [isSaving, setIsSaving] = useState(false);
    const [esCedulaConyugue, setEsCedulaConyugue] = useState(false);

    useEffect(() => {
        editFicha();
        // eslint-disable-next-line
    }, [id]);

    const editFicha = () => {
        setIsLoading(true);
        empleadoService.consultarEmpleado(id, 'seccion2').then(res => {
            const cats = catalogos;
            const _emp = res.data.empleado;

            if (!_emp) {
                reset(defaultValues);
                setIsLoading(false);
                return;
            }

            _emp.fecha_nacimiento_conyugue = generic.stringToDate(_emp.fecha_nacimiento_conyugue);
            setEsCedulaConyugue(_emp.tipo_identificacion_conyugue?.cat_id === cats.cedula?.cat_id);

            reset(generic.renewValues(_emp, omodel.model));
        }).finally(() => setIsLoading(false));
    }

    const onSubmit = (data) => {
        setIsSaving(true);
        data.id = id;
        data.indice = 1;
        data.casado = catalogos?.casado;
        data.union = catalogos?.union;
        data.fecha_nacimiento_conyugue = data.fecha_nacimiento_conyugue ? generic.dateToString(data.fecha_nacimiento_conyugue) : null;
        data.tipoFrmEmpresa = catalogos?.tipoFrmEmpresa;
        data.seccion = 'seccion2';

        empleadoService.editarEmpleado(data).then(res => {
            generic.funcSuccess(res, toast);
            next();
        }).catch(error => {
            generic.funcError(error, toast, setError);
        }).finally(() => setIsSaving(false));
    }

    const onError = () => {
        toast.current.show({ severity: 'error', summary: 'Error', detail: 'Se detectaron errores, por favor revise el formulario para corregir.', life: 3000 });
    }

    const onChangeTipo = (e) => {
        setEsCedulaConyugue(e.value?.cat_id === catalogos?.cedula?.cat_id);
        clearErrors('identificacion_conyugue');
    }

    const tipoDoc = esCedulaConyugue ? 'IDEN_CEDULA' : null;

    const reglaValidacion = (val) => {
        if (!tipoDoc) return true;
        return generic.validarIdentificacionEcuador(val, tipoDoc) || 'Cédula incorrecta';
    };

    if (isLoading) {
        return (
            <div className="flex flex-column align-items-center justify-content-center p-5">
                <ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth="4" animationDuration=".5s" />
                <span className="mt-3 text-color-secondary font-medium text-lg">Consultando información...</span>
            </div>
        );
    }

    return (
        <form onSubmit={handleSubmit(onSubmit, onError)} className="p-fluid">

            <Panel header={generic.renderPanelHeader('C', 'DATOS DEL CÓNYUGE / CONVIVIENTE', 'pi pi-users')} className="panel-ficha shadow-1 mb-4">
                <div className="formgrid grid">
                    {inText('nombres_conyugue', { icon: 'pi pi-user' }, 3)}
                    {inText('apellidos_conyugue', { icon: 'pi pi-user' }, 3)}
                    {inDrop('tipo_identificacion_conyugue', catalogos?.tipo_identificacion, { lab: omodel.optionLabel, chn: onChangeTipo }, 3)}
                    {inText('identificacion_conyugue', { validate: reglaValidacion, icon: 'pi pi-id-card' }, 3)}

                    {inDrop('nacionalidad_conyugue', catalogos?.nacionalidad, { lab: omodel.optionLabel }, 4)}
                    {inDrop('genero_cy', catalogos?.genero, { lab: omodel.optionLabel }, 4)}
                    {inCalendar('fecha_nacimiento_conyugue', {}, 4)}

                    <div className="col-12 mb-3 mt-4">
                        <div className="flex align-items-center">
                            <span className="text-800 font-bold text-base mr-3 flex align-items-center gap-2">
                                <i className="pi pi-briefcase text-primary"></i>
                                INFORMACIÓN LABORAL DEL CÓNYUGE
                            </span>
                            <div className="border-bottom-1 border-300 flex-grow-1" style={{ height: '1px' }}></div>
                        </div>
                    </div>

                    {inText('lugar_trabajo_conyugue', { icon: 'pi pi-building' }, 6)}
                    {inText('cargo_conyugue', { icon: 'pi pi-briefcase' }, 6)}

                    <InputActividadEconomica name="actividad_economica" control={control} modelDef={omodel.model['actividad_economica']} disabled={soloLectura} col={12} />
                </div>
            </Panel>

            <BottomActionBar onPrev={handlePrev} onNext={next} loading={isSaving} isReadOnly={soloLectura} />
        </form>
    );
}
